import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsGETApiAuth, AdsPOSTApi, AdsPUTApi } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import Database from '../../../../Constant/database.json'
import ImageUpload from "../../../ImageUpload";
import ExamQuestionModal from "./ExamQuestionModal";
import { CustomButtonUnSelect } from "../../../CustomButtomUnselect";
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import './formcss.css'
const QuestionBlock = [
  "question_number",
  "question",
  "question_description",
  "question_description_type",
  "question_media",
  "question_media_type",
  "option_1",
  "option_2",
  "option_3",
  "option_4",
  "answer_description",
  "correct_answer",
  "answer_media_type",
]

export default function FormComponent(props) {
  const { FetchData, db_slug, webSlug } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  const [Time, setTime] = React.useState(FetchData.meta.exam_time)
  const [Details, setDetails] = React.useState(FetchData.meta.exam_details)
  const [Available, setAvaliable] = React.useState(FetchData.meta.available_unavailable)
  const [FeaturedImage, setFeaturedImage] = React.useState(FetchData.meta.featured_image)
  const [ExamType, setExamType] = React.useState(FetchData.meta.exam_type)
  const [CopyTo, setCopyTo] = React.useState("Demo Exam")
  const [AudioSingle, setAudioSingle] = React.useState(FetchData.meta.media_non_repeat)
  const [ExamPrice, setExamPrice] = React.useState(FetchData.meta.exam_price)
  const [ExamCode, setExamCode] = React.useState(FetchData.meta.exam_code)

  const [QuestionsBlock, setQuestionsBlock] = React.useState(false);
  const [QuestionsData, setQuestionsData] = React.useState(
    db_slug == slugs.db_slug_demo_exam ?
      JSON.parse(FetchData.meta.exam_question_text) :
      JSON.parse(FetchData.meta.exam_question_block_text)
  );
  const [ExamSubType, setExamSubType] = React.useState(
    FetchData.meta.exam_sub_type
  );
  const [QuestionsEditMode, setQuestionsEditMode] = React.useState(false);
  const [QuestionsEditData, setQuestionsEditData] = React.useState({});
  const [QuestionsEditKey, setQuestionsEditKey] = React.useState();
  const [ArrayIndex, setArrayIndex] = React.useState(0);

  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")

  const EditInfo = (wholeedit) => {
    setReload(true)
    console.log(QuestionsData)
    var data;
    data = {
      "title": Title,
      "status": "publish",
      "meta": {
        "exam_question_block_text": JSON.stringify(QuestionsData),
        "exam_time": Time,
        "exam_details": Details,
        "available_unavailable": Available,
        "featured_image": FeaturedImage,
        "media_non_repeat": AudioSingle,
        "exam_type": ExamType,
        "exam_sub_type": ExamSubType,
        "exam_price": ExamPrice,
        "exam_code": ExamCode
      }
    }


    if (ID === "")
      AdsPOSTApi(data, slugs.db_slug_paid_exam)
        .then((res) => {
          setReload(false)
          setID(res.data.id)
          setAlertShow(true)
          setAlertcomp("Exam Added Successfully")
          console.log(res.data)
          history.push(`${slugs.exam_details}${res.data.slug}`)
        }).catch(err => {
          setReload(false)
          console.log(err)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
    else
      AdsPUTApi(data, slugs.db_slug_paid_exam, ID)
        .then((res) => {
          setReload(false)
          if (wholeedit) {
            setAlertShow(true)
            setAlertcomp(`${Title} edited Successfully`)
          }
        }).catch(err => {
          console.log(err)
          console.warn(err.response.data)
          console.log("Response Status: hello11", err.response.status);
          console.log("Response Headers:", err.response.headers);
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }
  const [batchID, setBatchID] = React.useState(FetchData.meta.batch_id)
  const [batchName, setBatchName] = React.useState(FetchData.meta.batch_name)
  const [batchModal, setBatchModal] = React.useState(false)
  const [batchList, setBatchList] = React.useState([])

  useEffect(() => {
    if (db_slug == "daily_exam")
      BatchList()
  }, [])
  const BatchList = () => {
    AdsGETApiAuth(
      { per_page: 100, _fields: "id,title,meta.batch_status,meta.batch_start_date,meta.batch_end_date" },
      slugs.db_slug_batch
    )
      .then((res) => {
        setBatchList(res.data)
      })
      .catch(e => {
        console.log(e)
      })
  }
  const StudentExportRef5 = React.useRef(null);
  const StudentExportPrint5 = useReactToPrint({
    content: () => StudentExportRef5.current,
    pageStyle: { margin: "10px" },
    // pageStyle:`
    // margin:100px;
    // `,

  })
  const onChangeFunction = (key, value, index) => {
    const date = new Date()

    var changeValue = {
      ...Object.values(QuestionsData)[index],
      [key]: value,
      "question_date": `${date.toDateString()}, ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`,
    }

    var AllChange = {
      ...QuestionsData,
      [Object.keys(QuestionsData)[index]]: changeValue
    }
    setQuestionsData(AllChange)
    console.log(date.toDateString(), QuestionsData[Object.keys(QuestionsData)[index]])

  }
  // var type = location.pathname.slice(slugs.new_exam.length + 1) == "" ? "ubt" : location.pathname.slice(slugs.all_exam.length + 1)

  return (
    <div>
      <div className="row">
        <div className="col-sm-2 col-1"></div>
        <div className="col-sm-8 col-10 form-view mb-3">
          <h4><center>Exam Information</center></h4>

          <table>
            <tbody>
              <tr>
                <td className="col-3">Exam Name</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Title} placeholder="Name"
                    onChange={(event) => { setTitle(event.target.value) }}
                  />
                </td>
              </tr>

              <tr>
                <td className="col-3">Exam Time (in minutes)</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Time} placeholder="Exam Time"
                    onChange={(event) => { setTime(event.target.value) }}
                  />
                </td>
              </tr>
              {/* {db_slug == "paid_exam" &&
                <tr>
                  <td className="col-3">Exam Price</td>
                  <td className="col-6">
                    <input className="input-common"
                      value={ExamPrice} placeholder="Exam Price"
                      onChange={(event) => { setExamPrice(event.target.value) }}
                    />
                  </td>
                </tr>
              } */}
              {db_slug == "weekly_free_exam" &&
                <tr>
                  <td className="col-3">Exam Code</td>
                  <td className="col-6">
                    <input className="input-common"
                      value={ExamCode} placeholder="Exam Code"
                      onChange={(event) => { setExamCode(event.target.value) }}
                    />
                  </td>
                </tr>
              }
              <tr>
                <td className="col-3">Exam Details</td>
                <td className="col-6">
                  <textarea rows={5} className="input-common"
                    value={Details} placeholder="Exam Details"
                    onChange={(event) => { setDetails(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Featured Image</td>
                <td className="col-6">
                  <ImageUpload
                    ImageUrl={FeaturedImage}
                    setImageUrl={setFeaturedImage}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Audio Single</td>
                <td className="col-6">
                  <div style={{ display: "inline" }}>
                    <div style={{ display: "inline-block" }}>
                      <CustomButtonUnSelect setData={setAudioSingle} Data={AudioSingle} DataValue={"Single"} />
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td className="col-3">Exam Availability</td>
                <td className="col-6">
                  <CustomButton setData={setAvaliable} Data={Available} DataValue={"Available"} />
                  <CustomButton setData={setAvaliable} Data={Available} DataValue={"Unavailable"} />
                </td>
              </tr>

              {/* <tr>
                <td className="col-3">Exam Type</td>
                <td className="col-6">
                  <div style={{ display: "inline" }}>
                    {db_slug == slugs.db_slug_demo_exam ?
                      <>
                        {Database.exam_type.map((item, index) => (
                          <div style={{ display: "inline-block" }} key={index}>
                            <CustomButton setData={setExamType} Data={ExamType} DataValue={item} />
                          </div>
                        ))}
                      </>
                      :
                      <>
                        {(ExamType == "UBT" || ExamType == "Agriculture" || ExamType == "Ship Building" || ExamType == "Manufacturing") ?
                          <div />
                          :
                          <CustomButton setData={setExamType} Data={ExamType} DataValue={ExamType} />
                        }
                      </>
                    }
                    {(ExamType == "UBT" || ExamType == "Agriculture" || ExamType == "Ship Building" || ExamType == "Manufacturing") &&
                      <>
                        <CustomButton setData={setExamType} Data={ExamType} DataValue={"UBT"} />
                       <CustomButton setData={setExamType} Data={ExamType} DataValue={"Agriculture"} />
                        <CustomButton setData={setExamType} Data={ExamType} DataValue={"Ship Building"} />
                        <CustomButton setData={setExamType} Data={ExamType} DataValue={"Manufacturing"} />
                      </>
                    }

                  </div>
                </td>
              </tr> */}
              <tr>
                <td className="col-3">Free Exam</td>
                <td className="col-6">
                  <div style={{ display: "inline" }}>
                    <div style={{ display: "inline-block" }}>
                      <CustomButtonUnSelect setData={setExamSubType} Data={ExamSubType} DataValue={"Free"} />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo(true)
                }}
              >
                Update Exam
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12 mb-3">
          {/* <h4><center>Questions</center></h4> */}
          {/* <div style={{ display: "inline", justifyContent: "flex-end" }}>
            <div style={{ cursor: "pointer", display: "inline-block", margin: "5px", color: QuestionsBlock ? "#000000" : "#444444", fontWeight: QuestionsBlock ? "bold" : "normal" }}
              onClick={() => {
                setQuestionsBlock(true)
              }}
            >
              Block
            </div>
            <div style={{ cursor: "pointer", display: "inline-block", margin: "5px", color: !QuestionsBlock ? "#000000" : "#444444", fontWeight: !QuestionsBlock ? "bold" : "normal" }}
              onClick={() => {
                setQuestionsBlock(false)
              }}
            >
              Table
            </div>
          </div> */}
          <div>
            <div className="row center m-2">
              <div className=" col-3" style={{ padding: "0 10px" }}>
                <div className="sign-in-button-4"
                  onClick={() => {
                    var Question = {
                      "question_number": `${Object.keys(QuestionsData).length + 1}`,
                      "question": "",
                      "question_description": "",
                      "question_box_text": "",
                      "question_date": "",
                      "question_image": "",
                      "question_audio": "",
                      "option_1": "",
                      "option_1_text": "",
                      "option_2": "",
                      "option_2_text": "",
                      "option_3_text": "",
                      "option_3": "",
                      "option_4": "",
                      "option_4_text": "",
                      "answer_description": "",
                      "correct_answer": "option 1",
                      "answer_media_type": "text",
                    }

                    var newQuestion = {
                      ...QuestionsData,
                      [`item-${Object.values(QuestionsData).length}`]:
                        Question
                    }
                    setQuestionsData(newQuestion)
                    setQuestionsEditMode(true)
                    setQuestionsEditData(Question)
                    setQuestionsEditKey(`item-${Object.keys(newQuestion).length}`)
                  }}
                >
                  Add Question
                </div>
              </div>
            </div>
          </div>
          {QuestionsBlock ?
            <div>
              <div className="row m-4">
                <div className="col-6">
                  <div className="row">
                    {Object.values(QuestionsData).map((item, index) => {
                      if (index < Object.values(QuestionsData).length / 2)
                        return (
                          <div key={index} className="col-2 p-2 center"
                            style={{
                              margin: "5px",
                              backgroundColor: item.question !== "" ? "#fad4d4" : "#fafad4",
                              fontWeight: "bold",
                              border: "2px solid black",
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              setQuestionsEditData(item)
                              setQuestionsEditKey(Object.keys(QuestionsData)[index])
                              setQuestionsEditMode(true)
                            }}
                          >
                            {item.question_number}
                          </div>
                        )
                    })}
                  </div>
                </div>
                <div className="col-6">
                  <div className="row">
                    {Object.values(QuestionsData).map((item, index) => {
                      if (index >= Object.values(QuestionsData).length / 2)
                        return (
                          <div key={index} className="col-2 p-2 center"
                            style={{
                              margin: "5px",
                              backgroundColor: item.question !== "" ? "#fad4d4" : "#fafad4",
                              fontWeight: "bold",
                              border: "2px solid black",
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              setQuestionsEditData(item)
                              setQuestionsEditKey(Object.keys(QuestionsData)[index])
                              setQuestionsEditMode(true)
                            }}
                          >
                            {item.question_number}
                          </div>
                        )
                    })}
                  </div>
                </div>
              </div>
            </div>
            :
            <div style={{
              // margin: "20px",
              // display: "none",
            }}
            >
              <div >
                <div className="col-12 mb-3" style={{ padding: "20px" }}>
                  <div style={{ overflowX: "scroll", }}>
                    {Object.values(QuestionsData).map((oneQuestionData, index) => (
                      <section key={index} style={{
                        pageBreakInside: "avoid", display: "block", cursor: "pointer", padding: "3px 0",
                      }}


                      >
                        <div className="quiz-container">
                          <div
                            style={{
                              margin: "5px 20px",
                              paddingTop: "20px"
                            }}
                            onClick={() => {
                              // setQuestionsEditData(oneQuestionData)
                              // setQuestionsEditKey(Object.keys(QuestionsData)[index])
                              // setQuestionsEditMode(true)
                              // setArrayIndex(index)
                            }}
                          >
                            <div >
                              <div>
                                <div style={{ padding: "5px 0 0 0" }}>
                                  <h3 style={{ fontSize: "18px", fontWeight: "bold", margin: 0, paddingBottom: 0 }}>
                                    {/* {oneQuestionData.question_number}. {oneQuestionData.question} */}
                                    {index + 1}. {oneQuestionData.question}
                                  </h3>
                                </div>
                                <span style={{ color: "#d9d502", fontSize: "9px", marginLeft: "20px" }}>Modified: {oneQuestionData.question_date}</span>

                                {oneQuestionData.question_text}
                                <div className="question-description ">
                                  {oneQuestionData.question_description !== "" &&
                                    <div style={{
                                      fontSize: "15px",
                                      padding: "0 0 15px"
                                    }}>
                                      <div dangerouslySetInnerHTML={{ __html: oneQuestionData.question_description.replaceAll('\n', '<br/>') }}></div>
                                    </div>
                                  }
                                  {oneQuestionData.question_image !== "" &&
                                    <>
                                      <div style={{ padding: "2px", textAlign: "center", }} >
                                        <img
                                          src={oneQuestionData.question_image}
                                          style={{
                                            height: "150px",
                                            width: "392px",
                                            objectFit: 'contain',
                                            padding: "2px",
                                            border: "0.5px solid #999",
                                          }}
                                        />
                                      </div>
                                    </>
                                  }
                                  {oneQuestionData.question_audio.includes("https:") &&
                                    <div>
                                      <audio controls>
                                        <source src={`${oneQuestionData.question_audio}`} type="audio/mpeg" />
                                        <source src={`${oneQuestionData.question_audio}`} type="audio/mp3" />
                                        <source src={`${oneQuestionData.question_audio}`} type="audio/wav" />
                                        <source src={`${oneQuestionData.question_audio}`} type="audio/ogg" />
                                        Your browser does not support the audio element.
                                      </audio>
                                    </div>
                                  }
                                </div>


                                <div className="">
                                  {oneQuestionData.question_box_text !== "" &&
                                    <div style={{
                                      border: "0.5px solid #999",
                                      padding: "5px ",
                                      justifyContent: 'center',
                                      display: "flex",
                                      width: "100%"
                                    }}>
                                      <div style={{ fontSize: "16px" }} dangerouslySetInnerHTML={{ __html: oneQuestionData.question_box_text.replaceAll('\n', '<br/>') }}></div>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                            <div
                            // className={oneQuestionData.answer_media_type == "image" ? "col-md-12 ms-5" : "col-md-4"}
                            >
                              <div
                                className={"row"}
                                style={{
                                  margin: "0 10px"
                                }} >
                                <AnswerBlock index={1}
                                  DataValue={oneQuestionData.option_1}
                                  DataValueText={oneQuestionData.option_1_text}
                                  DataType={oneQuestionData.answer_media_type} correct_answer={oneQuestionData.correct_answer} option={"option 1"} />
                                <AnswerBlock index={2}
                                  DataValueText={oneQuestionData.option_2_text}
                                  DataValue={oneQuestionData.option_2} DataType={oneQuestionData.answer_media_type} correct_answer={oneQuestionData.correct_answer} option={"option 2"} />
                                <AnswerBlock index={3}
                                  DataValueText={oneQuestionData.option_3_text}
                                  DataValue={oneQuestionData.option_3} DataType={oneQuestionData.answer_media_type} correct_answer={oneQuestionData.correct_answer} option={"option 3"} />
                                <AnswerBlock index={4}
                                  DataValueText={oneQuestionData.option_4_text}
                                  DataValue={oneQuestionData.option_4} DataType={oneQuestionData.answer_media_type} correct_answer={oneQuestionData.correct_answer} option={"option 4"} />
                              </div>
                            </div>
                          </div>
                          <div className="row center m-2 p-2">
                            <div className=" col-2" style={{ padding: "0 10px" }}>
                              <div
                                onClick={() => {
                                  // EditInfo(true)
                                  navigator.clipboard.writeText(JSON.stringify(oneQuestionData))
                                  const newObject = QuestionsData;
                                  // Object.keys(QuestionsData).forEach((key) => {
                                  //   newObject[key] = QuestionsData[key];
                                  //   if (key === Object.keys(QuestionsData)[index]) {
                                  //     newObject[newKey] = newValue;
                                  //   }
                                  // });
                                  delete newObject[Object.keys(QuestionsData)[index]]
                                  console.log(newObject, Object.keys(QuestionsData)[index])
                                  // set
                                  setQuestionsEditData(oneQuestionData)
                                  setQuestionsEditKey(Object.keys(QuestionsData)[index])

                                  setQuestionsEditMode(true)
                                  setTimeout(() => {
                                    setQuestionsEditMode(false)
                                  }, 300)

                                }}
                              >
                                Delete
                              </div>
                            </div>
                            <div className=" col-2" style={{ padding: "0 10px" }}>
                              <div
                                onClick={() => {
                                  EditInfo(true)

                                }}
                              >
                                Update
                              </div>
                            </div>
                            <div className=" col-2" style={{ padding: "0 10px" }}>
                              <div
                                onClick={() => {
                                  // EditInfo(true)
                                  setQuestionsEditData(oneQuestionData)
                                  setQuestionsEditKey(Object.keys(QuestionsData)[index])
                                  setQuestionsEditMode(true)
                                  setArrayIndex(index)
                                }}
                              >
                                Edit
                              </div>
                            </div>
                            <div className=" col-2" style={{ padding: "0 10px" }}>
                              <div
                                onClick={() => {
                                  // EditInfo(true)
                                  // setQuestionsEditData(oneQuestionData)
                                  // setQuestionsEditKey(Object.keys(QuestionsData)[index])
                                  // setQuestionsEditMode(true)
                                  // setArrayIndex(index)
                                  navigator.clipboard.writeText(JSON.stringify(oneQuestionData))

                                }}
                              >
                                Copy
                              </div>
                            </div>
                            <div className=" col-2" style={{ padding: "0 10px" }}>
                              <div
                                onClick={async () => {
                                  // EditInfo(true)
                                  // setQuestionsEditData(oneQuestionData)
                                  // setQuestionsEditKey(Object.keys(QuestionsData)[index])
                                  // setQuestionsEditMode(true)
                                  // setArrayIndex(index)
                                  var pasteValue = await navigator.clipboard.readText()
                                  var parseValue = JSON.parse(pasteValue)
                                  var AllChange = {
                                    ...QuestionsData,
                                    [Object.keys(QuestionsData)[index]]: parseValue
                                  }
                                  setQuestionsData(AllChange)
                                }}
                              >
                                Paste
                              </div>
                            </div>
                            <div className="col-2" style={{ padding: "0 10px" }}>
                              {/* {Object.keys(QuestionsData)[index]} */}
                              <div
                                onClick={async () => {
                                  var newValue = {
                                    "question_number": `${Object.keys(QuestionsData).length + 1}`,
                                    "question": "",
                                    "question_description": "",
                                    "question_box_text": "",
                                    "question_date": "",
                                    "question_image": "",
                                    "question_audio": "",
                                    "option_1": "",
                                    "option_1_text": "",
                                    "option_2": "",
                                    "option_2_text": "",
                                    "option_3_text": "",
                                    "option_3": "",
                                    "option_4": "",
                                    "option_4_text": "",
                                    "answer_description": "",
                                    "correct_answer": "option 1",
                                    "answer_media_type": "text",
                                  }
                                  const newKey = `item-${Object.keys(QuestionsData).length + 1}`
                                  const newObject = {};
                                  Object.keys(QuestionsData).forEach((key) => {
                                    newObject[key] = QuestionsData[key];
                                    if (key === Object.keys(QuestionsData)[index]) {
                                      newObject[newKey] = newValue;
                                    }
                                  });
                                  // var allkeys = Object.keys(QuestionsData)
                                  // var keyvalue = []
                                  // for (let i = 0; i < allkeys.length; i++) {
                                  //   keyvalue.push(Number(allkeys[i].replace("item-", "")))
                                  // }
                                  // var sortkeys = keyvalue.sort((a, b) => a - b)

                                  // var newQuestion = {
                                  //   ...QuestionsData,
                                  //   [`item-${sortkeys[sortkeys.length - 1] + 1}`]:
                                  //     newValue
                                  // }
                                  setQuestionsData(newObject)
                                }}
                              >
                                <span style={{ color: "#000", fontWeight: "bold" }}>
                                  Add
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* {Object.keys(QuestionsData)[index]} */}
                      </section>
                    ))}
                  </div>

                </div>
              </div>
            </div>

          }
          { }
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  var Question = {
                    "question_number": `${Object.keys(QuestionsData).length + 1}`,
                    "question": "",
                    "question_description": "",
                    "question_box_text": "",
                    "question_date": "",
                    "question_image": "",
                    "question_audio": "",
                    "option_1": "",
                    "option_1_text": "",
                    "option_2": "",
                    "option_2_text": "",
                    "option_3_text": "",
                    "option_3": "",
                    "option_4": "",
                    "option_4_text": "",
                    "answer_description": "",
                    "correct_answer": "option 1",
                    "answer_media_type": "text",
                  }
                  var allkeys = Object.keys(QuestionsData)
                  var keyvalue = []
                  for (let i = 0; i < allkeys.length; i++) {
                    keyvalue.push(Number(allkeys[i].replace("item-", "")))
                  }
                  var sortkeys = keyvalue.sort((a, b) => a - b)

                  var newQuestion = {
                    ...QuestionsData,
                    [`item-${sortkeys[sortkeys.length - 1] + 1}`]:
                      Question
                  }
                  setQuestionsData(newQuestion)
                  // setQuestionsEditMode(true)
                  // setQuestionsEditData(Question)
                  // setQuestionsEditKey(`item-${Object.keys(newQuestion).length}`)
                }}
              >
                Add Question
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="row">
        <div className="col-1"></div>
        <div className="col-10 form-view mb-3">


          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo("", slugs.db_slug_demo_exam, slugs.demo_exam_details)
                }}
              >
                Copy to Free Exam
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {
        QuestionsEditMode &&
        <section className="modal" style={{ overflowX: 'hidden', }}>
          <div className="row" style={{ overflowX: 'hidden', }}>
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10  shadow bg-white" style={{ borderRadius: "10px", }}>
              <div style={{ margin: " 10px", overflowX: 'hidden', padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setQuestionsEditMode(false)
                    setQuestionsEditData([])
                    setQuestionsEditKey("")
                  }}
                >X</div>
                <ExamQuestionModal
                  oneQuestionData={QuestionsEditData}
                  keyValue={QuestionsEditKey}
                  AllQuestionData={QuestionsData}
                  setAllQuestionData={setQuestionsData}
                  PostExam={EditInfo}
                  setEditQuestion={setQuestionsEditMode}
                  setQuestionsEditMode={setQuestionsEditMode}
                  setQuestionsEditData={setQuestionsEditData}
                  setQuestionsEditKey={setQuestionsEditKey}
                  ArrayIndex={ArrayIndex}
                  setArrayIndex={setArrayIndex}
                  onChangeFunction={onChangeFunction}
                  EditInfo={EditInfo}
                />
              </div>
            </div>
          </div>
        </section>
      }

      {
        reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }
    </div >
  )

}


const AnswerBlock = ({ DataValueText, index, DataType, DataValue, correct_answer, option }) => {
  return (
    <div
      className={"col-6"}
      style={{
        borderLeft: option == correct_answer ? "2px solid green" : 0,
        display: 'flex',
        padding: "15px 10px",
      }}
    >
      <div style={{ marginRight: "5px", cursor: "pointer" }}>
        <div style={{
          border: option == correct_answer ? "2px solid green" : "2px solid black",
          backgroundColor: option == correct_answer ? "green" : "#fff",
          color: option == correct_answer ? "#fff" : "#000",
          borderRadius: "14px",
          width: "20px",
          height: "20px", display: "flex", justifyContent: "center", alignContent: "center",
          fontSize: "12px", fontWeight: "bold"
        }}>
          &nbsp;{index}&nbsp;
        </div>
      </div>
      <div style={{ fontSize: "16px" }} className="passive-option2">
        {/* {DataType == "text" &&
          `${DataValue}`
        } */}
        {/* {DataType == "text" &&
          `${DataValue}`
        } */}
        {(DataType == "text" || DataType == "underline") &&
          <span  >
            <div dangerouslySetInnerHTML={{ __html: DataValue.replace(DataValueText, `<u>${DataValueText}</u>`) }}></div>
            {/* {DataValue}  */}
          </span>
        }
        {DataType == "image" &&
          <>
            <img
              src={DataValue}
              style={{
                width: "120px",
                border: "0.5px solid #000"
              }}
            />
          </>
        }
        {DataType == "audio" &&
          <div>
            <audio controls>
              {/* <source src={`${ImageUrl}`} type="audio/ogg" /> */}
              <source src={`${DataValue}`} type="audio/mpeg" />
              <source src={`${DataValue}`} type="audio/mp3" />
              <source src={`${DataValue}`} type="audio/wav" />
              <source src={`${DataValue}`} type="audio/ogg" />
              Your browser does not support the audio element.
            </audio>
            <a href={DataValue} target="_blank">
              <div style={{ cursor: "pointer" }} onClick={() => { }}>
                <div>
                </div>
              </div>
            </a>
          </div>
        }
      </div>
    </div>
  )
}